import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Feature, FeatureSection, Header, HomePageContainer } from "../../styled/Homepage";
import Alert from "../components/Alert";
import { AddUserButton, CreateButton } from "../components/Button";
import { SuccessMessage } from "../components/Form";
import TableData from "./DataTable";
import Form from "./Form";

const HomePage = ({
  handleAutoLogout = () => console.log('for logout')
}) => {
  const [showCreate, setShowCreate] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showErrorLoad, setShowErrorLoad] = useState(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const id = urlSearchParams.get('t');

  const [data, setData] = useState({
    prompt: "",
    kata_client_id: Date.now(),
    client_name: "",
    whatsapp_number: "",
    prompt_tag: "",
    user_data: [],
    intent: [],
    fileupload: undefined,
    username: "",
    password: "",
    expiry_date: 0,
    prompt_rephraser: "",
    embedding_type: "azure"
});

const checkExpiredCookie = () => {
  const auth = Cookies.get('gen.ui.authentication');

  if (!auth) {
    setShowAlert(true);
    setTimeout(() => {
      handleAutoLogout(false);
    }, 5000)
  }
}

const parseFromJson = (json) => {
    return Object.keys(json).map(key => {
        const product = json[key];
        
        return {
            value: product,
            key: key // Use the original key as a property
        };
    });
}

const getDetail = async (clientId) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_BASE_URL}${clientId}`,
    headers: { }
  };

  await axios.request(config).then((resp) => {
    setData({
      ...resp.data,
      product_data: resp.data.product_data && resp.data.product_data !== "" ? parseFromJson(JSON.parse(resp.data.product_data)) : [],
      user_data: resp.data.user_data && resp.data.user_data !== "" ? parseFromJson(JSON.parse(resp.data.user_data)) : [],
      expiry_date: resp.data.expiration_day,
      password: "",
      filename: resp.data.vectordb_collection && resp.data.vectordb_collection[resp.data.vectordb_collection.length - 1] && resp.data.vectordb_collection[resp.data.vectordb_collection.length - 1].source,
      fileupload: resp.data.vectordb_collection,
      embedding_type: resp.data.embedding_type || "azure"
    })
    setShowCreate(true)
    window.history.replaceState(null, "Details", `?t=${clientId}`)
  }).catch(() => {
    setShowErrorLoad(true)
    setTimeout(() => {
      setShowErrorLoad(false)
    }, 5000)
  })
}

setInterval(() => {
  checkExpiredCookie()
}, 5000)

useEffect(() => {
  if (id) {
    getDetail(id)
  }
  // eslint-disable-next-line
}, [id])

  return (
    <HomePageContainer>
      <Header>
        <h1>Kata - Gen UI</h1>
        <p>For Internal purpose only</p>
        <p>Apologies, folks. We didn't have the time to make this page look even cooler</p>
      </Header>
      <AddUserButton type="button" variant="#d94115" onClick={() => {
        Cookies.remove("gen.ui.authentication")
        handleAutoLogout(false)
      }}>Logout</AddUserButton>
      <FeatureSection>
        <Feature>
          {showSuccess && <SuccessMessage>Saved Success</SuccessMessage>}
          {!showCreate && 
            <CreateButton onClick={() => {
              setData({
                prompt: "",
                kata_client_id: Date.now(),
                client_name: "",
                whatsapp_number: "",
                prompt_tag: "",
                fileupload: undefined,
                user_data: [],
                intent: []
            })
              setShowCreate(true)
            }}> 
              Create 
            </CreateButton>}

          {showCreate ? 
            <Form 
              returnFromSubmit={() => {
                setShowSuccess(true)
                window.location.href = "/"
                setTimeout(() => {
                  setShowSuccess(false)
                }, 1000)
              }}
              cancelSubmit={() => {
                window.location.href = "/"
              }}
              data={data} 
            /> 
            : 
            <TableData 
              onSelect={async (rec) => {
                getDetail(rec.kata_client_id)
              }}
            />
          }
        </Feature>
      </FeatureSection>
      <Alert 
        backgroundColor="#d2161675"
        isVisible={showErrorLoad}
      >
        Something wrong when load details
      </Alert>
      <Alert 
        backgroundColor="#d2161675"
        isVisible={showAlert}
      >
        Session is expired, logout automatically
      </Alert>
    </HomePageContainer>
  );
}

export default HomePage;